module.exports = __webpack_public_path__ + "static/img/vdwap.3611ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/vdwap.png
// module id = KP+V
// module chunks = 0